var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"friend_link"},[_vm._v(" Powered By "),_c('a',{staticStyle:{"color":"skyblue"},attrs:{"href":"https://v2.cn.vuejs.org/"}},[_vm._v("Vue2.x")])])])
}]

export { render, staticRenderFns }